import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.Preset')
export class Preset extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'title')
  title: string;

  @JsonProperty([Number], 'columnsId')
  columnsId: number[];
}

